module.exports = __webpack_public_path__ + "img/hero-3-concealed-guide-top.85857bda.png";